import React from 'react';
import styled from 'styled-components';
import cover1 from '../../../assets/images/cover1.jpg';
import cover2 from '../../../assets/images/cover2.jpg';
import cover3 from '../../../assets/images/cover3.jpg';
import divider from '../../../assets/images/divider.png';
import Spacer from '../../shared/Spacer';
import Contact from './Contact';
import Footer from './Footer';
import How from './How';
import Why from './Why';

const Cover = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  img {
    width: 100%;
  }
  @media (max-width: 1000px) {
    flex-direction: column;
  }
`;
const LeftRow = styled.div`
  display: flex;
  flex-direction: column;
  width: 43.4%;
  img {
    z-index: 2;
  }

  @media (max-width: 1000px) {
    width: 100%;
  }
`;
const RightRow = styled.div`
  display: flex;
  flex-direction: column;
  width: 56.6%;
  img {
    z-index: 2;
  }
  @media (max-width: 1000px) {
    width: 100%;
  }
`;

const Divider = styled.div`
  overflow: hidden;
  img {
    min-width: 100%;
    max-width: 200%;
  }
`;

const Content = () => (
  <>
    <Spacer white marginTop="50px" marginBottom="50px" />
    <Why />
    <Cover id="takeatour">
      <LeftRow>
        <img src={cover1} alt="Cover" />
        <img src={cover2} alt="Cover" />
      </LeftRow>
      <RightRow>
        <img src={cover3} alt="Cover" />
      </RightRow>
    </Cover>
    <Spacer marginTop="50px" />
    <How />
    <Spacer white marginBottom="50px" />
    <Contact />
    <Divider>
      <img src={divider} alt="Cover" />
    </Divider>
    <Footer />
  </>
);

export default Content;
